<script lang="ts" setup>
import { useDialogStore } from "~/projects/cc/stores/dialogStore";

const dialogStore = useDialogStore();
</script>

<template>
  <el-dialog v-model="dialogStore.showCallWarning" width="30%">
    <div class="flex justify-center flex-col items-center gap-3">
      <svg
        fill="none"
        height="46"
        viewBox="0 0 52 46"
        width="52"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.2477 2.86925L50.8327 40.2555C52.276 42.7555 50.472 45.8805 47.5852 45.8805H4.41527C1.52852 45.8805 -0.275709 42.7555 1.16767 40.2555L22.7525 2.86928C24.196 0.369275 27.8045 0.36925 29.2477 2.86925ZM26.0002 32.5C24.6195 32.5 23.5002 33.6193 23.5002 35C23.5002 36.3807 24.6195 37.5 26.0002 37.5C27.381 37.5 28.5002 36.3807 28.5002 35C28.5002 33.6193 27.381 32.5 26.0002 32.5ZM26.0002 15C24.7181 15 23.6615 15.9651 23.5171 17.2085L23.5002 17.5V27.5C23.5002 28.8808 24.6195 30 26.0002 30C27.2824 30 28.339 29.0349 28.4834 27.7916L28.5002 27.5V17.5C28.5002 16.1193 27.381 15 26.0002 15Z"
          fill="#D83742"
        />
      </svg>
      <span> Do you want to call? </span>
      <span class="font-[600] text-black"> User's Name / Number </span>
    </div>
    <template #footer>
      <span class="flex justify-center">
        <el-button
          type="primary"
          @click.prevent="dialogStore.hideCallWarning()"
        >
          Yes
        </el-button>
        <el-button type="primary" @click.prevent="dialogStore.hideCallWarning()"
          >No</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<style scoped></style>
